// Per-city SEO landing page content for local search (GEO/AEO).
export const CITIES = {
  "sultan-wa": {
    slug: "sultan-wa",
    name: "Sultan",
    state: "WA",
    region: "Sky Valley, Snohomish County",
    zips: ["98294"],
    tagline: "Roofing Contractor in Sultan, WA",
    intro:
      "Honey Bee Roofing & Exteriors is your local, licensed roofing contractor in Sultan, WA. From the Skykomish River valley to the Sky Valley foothills, Sultan homes take a beating from heavy Pacific Northwest rain, wind, and moss. We deliver honest, flat-rate roof replacement, storm damage repair, and roof leak repair to keep your home dry and protected — backed by a 50-year CertainTeed guarantee.",
    weather:
      "Sultan's location along the US-2 corridor means wet winters, gusty windstorms off the Cascades, and constant moss growth on shaded north-facing roofs. We build and repair roofs specifically for these conditions — proper ventilation, quality flashing, and moss-resistant systems.",
    neighborhoods: ["Sultan Basin", "Sky Valley", "Old Town Sultan", "Sultan Heights", "US-2 Corridor"],
    nearby: ["Gold Bar", "Startup", "Monroe", "Index"],
    keywords:
      "roofers Sultan WA, roof repair Sultan WA, roof replacement Sultan, roofing contractor near me 425, roof leak repair Sultan, storm damage roof repair Sultan",
    faqs: [
      {
        q: "Do you offer roof leak repair in Sultan, WA?",
        a: "Yes. We provide prompt leak and storm damage repair throughout Sultan and the Sky Valley. We'll secure your roof to stop water intrusion, then schedule the permanent repair at a time that works for you.",
      },
      {
        q: "How much does a new roof cost in Sultan, WA?",
        a: "Cost depends on roof size, pitch, and materials. With our flat-rate pricing, you receive one fixed, written number after a free in-home evaluation — no surprises. Financing options are available for Sultan homeowners.",
      },
      {
        q: "Can you handle moss removal and roof maintenance in Sultan?",
        a: "Absolutely. Shaded, tree-lined Sultan properties are prone to moss. We provide inspections, moss treatment, and maintenance plans to extend the life of your roof in the wet Sky Valley climate.",
      },
    ],
  },
  "monroe-wa": {
    slug: "monroe-wa",
    name: "Monroe",
    state: "WA",
    region: "Snohomish County",
    zips: ["98272"],
    tagline: "Roofing Contractor in Monroe, WA",
    intro:
      "Looking for a trusted roofer in Monroe, WA? Honey Bee Roofing & Exteriors provides roof replacement, leak and storm damage repair, free inspections, siding and gutters across Monroe and Snohomish County. As a locally owned company, we know how Monroe's rainy, windy seasons wear on a roof — and we fix it right the first time with transparent, flat-rate pricing.",
    weather:
      "Sitting where US-2 meets SR-522, Monroe sees frequent rain, seasonal windstorms, and damp conditions that lead to leaks, lifted shingles, and clogged gutters. Our crews install durable, properly-vented CertainTeed roofing systems built for the Snohomish Valley.",
    neighborhoods: ["Downtown Monroe", "Fryelands", "Chain Lake", "Tualco Valley", "North Hill"],
    nearby: ["Snohomish", "Sultan", "Duvall", "Maltby"],
    keywords:
      "roofers Monroe WA, roof repair Monroe WA, roof replacement Monroe, roof leak repair Monroe WA, storm damage roof repair Monroe, licensed roofing contractor Monroe",
    faqs: [
      {
        q: "Are you a licensed roofing contractor in Monroe, WA?",
        a: "Yes — Honey Bee Roofing & Exteriors is a locally owned, licensed and insured Washington roofing contractor (WA Lic. #HONEYBE762PG) serving Monroe and all of Snohomish County.",
      },
      {
        q: "Can you help with a roof damage insurance claim in Monroe?",
        a: "Definitely. After wind or storm damage in Monroe, we thoroughly document the damage, provide the reports your insurer needs, and guide you through the entire claim process.",
      },
      {
        q: "How fast can you replace a roof in Monroe?",
        a: "Most Monroe roof replacements are completed in 1–4 days depending on size and weather. We give you a clear timeline up front and clean up thoroughly every single day.",
      },
    ],
  },
  "everett-wa": {
    slug: "everett-wa",
    name: "Everett",
    state: "WA",
    region: "Snohomish County",
    zips: ["98201", "98203", "98204", "98208"],
    tagline: "Roofing Contractor in Everett, WA",
    intro:
      "Honey Bee Roofing & Exteriors is a top-rated roofing company in Everett, WA. From waterfront homes near Puget Sound to neighborhoods across Snohomish County's largest city, we provide roof replacement, roof leak repair, storm damage restoration, inspections, siding and gutters. Honest, flat-rate pricing and a 50-year CertainTeed guarantee — that's the HoneyBee promise to Everett homeowners.",
    weather:
      "Everett's coastal Puget Sound climate brings persistent rain, salt air, and strong winter wind off the water — tough on shingles, flashing, and gutters. We install weather-tested roofing systems designed to stand up to everything the Sound throws at them.",
    neighborhoods: ["North Everett", "Bayside", "Silver Lake", "Riverside", "Port Gardner", "Harbour Pointe"],
    nearby: ["Marysville", "Mukilteo", "Lake Stevens", "Lynnwood"],
    keywords:
      "roofers Everett WA, roof repair Everett WA, roof replacement Everett, best roofing company Everett, roof leak repair Everett, commercial roofing contractor Everett",
    faqs: [
      {
        q: "How quickly can you repair a roof leak in Everett?",
        a: "We schedule prompt leak repairs across Everett — call us and we'll get you on the schedule fast to stop water intrusion before it harms your home's interior, then complete the permanent repair.",
      },
      {
        q: "Do you do both residential and commercial roofing in Everett?",
        a: "Yes. We handle residential roof replacement and repair as well as flat and low-slope commercial roofing systems for Everett property owners — TPO, EPDM, PVC, modified bitumen, standing-seam metal, and roof coatings.",
      },
      {
        q: "What roofing materials hold up best near Puget Sound?",
        a: "We recommend CertainTeed architectural asphalt shingles with upgraded ventilation and corrosion-resistant flashing — ideal for Everett's wet, salty coastal conditions.",
      },
    ],
  },
  "snohomish-wa": {
    slug: "snohomish-wa",
    name: "Snohomish",
    state: "WA",
    region: "Snohomish County",
    zips: ["98290", "98291", "98296"],
    tagline: "Roofing Contractor in Snohomish, WA",
    intro:
      "Honey Bee Roofing & Exteriors is the trusted local roofer in Snohomish, WA. From the historic downtown district to the homes along the Pilchuck and Snohomish Rivers, we provide roof replacement, leak and storm damage repair, free inspections, siding and gutters. Honest, flat-rate pricing and a 50-year CertainTeed guarantee for every Snohomish homeowner.",
    weather:
      "Snohomish's river-valley setting brings heavy seasonal rain, fog, and moss-friendly damp conditions that wear on roofs and gutters. We install well-ventilated, moss-resistant CertainTeed systems and keep historic-area homes looking their best.",
    neighborhoods: ["Historic Downtown", "Pilchuck", "Three Lakes", "Cathcart", "Clearview"],
    nearby: ["Monroe", "Everett", "Lake Stevens", "Maltby"],
    keywords:
      "roofers Snohomish WA, roof repair Snohomish WA, roof replacement Snohomish, roof leak repair Snohomish WA, licensed roofing contractor Snohomish, storm damage roof repair Snohomish",
    faqs: [
      {
        q: "Do you repair roofs on older or historic homes in Snohomish?",
        a: "Yes. Snohomish has many beautiful older and historic homes, and we take extra care to match materials and protect architectural character while bringing the roof up to modern, watertight standards.",
      },
      {
        q: "How quickly can you respond to a roof leak in Snohomish?",
        a: "We schedule prompt leak repairs across Snohomish — we'll secure the roof to stop water damage, then complete the permanent repair at your convenience.",
      },
      {
        q: "Do you offer free roof inspections in Snohomish, WA?",
        a: "Absolutely — we provide free, no-obligation in-home roof evaluations in Snohomish with a clear written report and fixed, flat-rate pricing.",
      },
    ],
  },
  "lake-stevens-wa": {
    slug: "lake-stevens-wa",
    name: "Lake Stevens",
    state: "WA",
    region: "Snohomish County",
    zips: ["98258"],
    tagline: "Roofing Contractor in Lake Stevens, WA",
    intro:
      "Need a dependable roofer in Lake Stevens, WA? Honey Bee Roofing & Exteriors delivers roof replacement, roof leak repair, storm damage restoration, inspections, siding and gutters throughout the Lake Stevens community. As a locally owned, licensed Washington contractor, we protect lakeside and hillside homes alike with flat-rate pricing and a 50-year CertainTeed guarantee.",
    weather:
      "Homes around Lake Stevens face high humidity, lake-effect moisture, and windy storm seasons that accelerate moss growth and shingle wear. Our roofing systems are built and ventilated specifically for these damp, breezy conditions.",
    neighborhoods: ["Lake Stevens Waterfront", "Frontier Village", "Soper Hill", "Davies Beach", "North Lakeshore"],
    nearby: ["Everett", "Marysville", "Snohomish", "Granite Falls"],
    keywords:
      "roofers Lake Stevens WA, roof repair Lake Stevens WA, roof replacement Lake Stevens, roof leak repair Lake Stevens, roof inspection Lake Stevens WA, affordable roofers Lake Stevens",
    faqs: [
      {
        q: "Do you handle moss and humidity issues common around Lake Stevens?",
        a: "Yes. Lakeside humidity makes moss and algae a frequent problem. We provide moss treatment, proper ventilation, and algae-resistant shingles to keep Lake Stevens roofs healthy longer.",
      },
      {
        q: "How much does a roof replacement cost in Lake Stevens?",
        a: "Pricing depends on roof size, pitch, and materials. With flat-rate pricing, you get one fixed, written quote after a free evaluation — plus financing options for Lake Stevens homeowners.",
      },
      {
        q: "Are you licensed and insured to work in Lake Stevens, WA?",
        a: "Yes — we're a locally owned, licensed and insured Washington roofing contractor (WA Lic. #HONEYBE762PG) serving Lake Stevens and all of Snohomish County.",
      },
    ],
  },
  "marysville-wa": {
    slug: "marysville-wa",
    name: "Marysville",
    state: "WA",
    region: "Snohomish County",
    zips: ["98270", "98271"],
    tagline: "Roofing Contractor in Marysville, WA",
    intro:
      "Honey Bee Roofing & Exteriors is a top-rated roofing company in Marysville, WA. From neighborhoods near the Tulalip area to homes throughout north Snohomish County, we provide roof replacement, roof leak repair, storm damage restoration, free inspections, siding and gutters. Honest, flat-rate pricing and a 50-year CertainTeed guarantee for every Marysville home.",
    weather:
      "Marysville's location near Port Susan and the Snohomish River delta brings damp, windy weather and frequent rain that stresses shingles, flashing, and gutters. We build durable, properly-vented roofing systems made to handle north Sound conditions.",
    neighborhoods: ["Downtown Marysville", "Sunnyside", "Kellogg Marsh", "Lakewood", "Smokey Point"],
    nearby: ["Everett", "Lake Stevens", "Arlington", "Tulalip"],
    keywords:
      "roofers Marysville WA, roof repair Marysville WA, roof replacement Marysville, best roofing company Marysville, roof leak repair Marysville, residential roofing services Marysville",
    faqs: [
      {
        q: "How quickly can you repair a roof leak in Marysville?",
        a: "We schedule prompt leak repairs across Marysville and Smokey Point — call us and we'll secure the roof quickly, protecting your home from further water intrusion, then complete the permanent repair.",
      },
      {
        q: "Can you help file a storm damage insurance claim in Marysville?",
        a: "Definitely. After wind or storm damage, we document everything thoroughly, provide the reports your insurer needs, and guide you through the entire Marysville insurance claim process.",
      },
      {
        q: "How long does a roof replacement take in Marysville?",
        a: "Most Marysville roof replacements are completed in 1–4 days depending on size and weather. We provide a clear timeline up front and clean up thoroughly every day, including a nail sweep.",
      },
    ],
  },
};

export const CITY_LIST = Object.values(CITIES);
